import React from 'react';

function GstinStep({ formData, handleInputChange, handleVerifyGSTIN, gstinError, isAnimating, gstVerified, handleNextStep, isReadOnly }) {
  // In readonly mode, we should always show the business details since the form has been submitted
  const shouldShowBusinessDetails = gstVerified || isReadOnly;
  
  return (
    <div className="onboarding-section gstin-verification">
      <div className="gstin-container">
        <h1 className="gstin-title">GSTIN Check</h1>
        <p className="gstin-subtitle">Please enter your GST Identification Number.</p>
        <p className="gstin-note">Note - Based on this entry, some of the details in the form will be automatically filled.</p>
        
        <div className="gstin-input-section">
          <label className="input-label">GSTIN Details</label>
          <div className="input-group">
            <input
              type="text"
              name="gstin"
              value={formData.gstin}
              onChange={handleInputChange}
              placeholder="Enter your GST Number"
              className="gstin-input"
              readOnly={isReadOnly}
            />
            <button 
              className={`verify-button ${isAnimating ? 'animating' : ''}`}
              onClick={handleVerifyGSTIN}
              disabled={isAnimating || !formData.gstin || isReadOnly}
            >
              {isAnimating ? 'VERIFYING...' : 'VERIFY'}
            </button>
          </div>
          {gstinError && (
            <div className="error-message">
              {gstinError}
            </div>
          )}
        </div>

        {shouldShowBusinessDetails && (
          <div className="business-details">
            <h2 className="details-title">YOUR BUSINESS DETAILS ARE SHOWN BELOW:</h2>
            <div className="details-grid">
              <div className="detail-item">
                <label>Registered Company Name</label>
                <p>{formData.companyName}</p>
              </div>
              <div className="detail-item">
                <label>PAN Number</label>
                <p>{formData.panNumber}</p>
              </div>
              <div className="detail-item">
                <label>Registration Date</label>
                <p>{formData.registrationDate}</p>
              </div>
              <div className="detail-item">
                <label>GSTIN Status</label>
                <p>{formData.gstinStatus}</p>
              </div>
              <div className="detail-item">
                <label>Taxpayer Type</label>
                <p>{formData.taxpayerType}</p>
              </div>
              <div className="detail-item">
                <label>Entity Type</label>
                <p>{formData.entityType}</p>
              </div>
              <div className="detail-item">
                <label>Registered Address</label>
                <p>{formData.address}</p>
              </div>
              <div className="detail-item">
                <label>City</label>
                <p>{formData.city}</p>
              </div>
              <div className="detail-item">
                <label>State</label>
                <p>{formData.state}</p>
              </div>
              <div className="detail-item">
                <label>Country</label>
                <p>{formData.country}</p>
              </div>
              <div className="detail-item">
                <label>Pincode</label>
                <p>{formData.pincode}</p>
              </div>
              <div className="detail-item">
                <label>GSTIN</label>
                <p>{formData.gstinNumber}</p>
              </div>
            </div>
            {!isReadOnly && (
              <button 
                className="confirm-button"
                onClick={handleNextStep}
              >
                CONFIRM & NEXT
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default GstinStep; 